export default __webpack_public_path__ + "static/portfolio_gallery_25-daf5629efc94b6b07e447e02a785d505.jpg";